export default __webpack_public_path__ + "static/media/researchSWS.e65f6581.jpg";